import * as Sentry from "@sentry/solidstart";
// import { solidRouterBrowserTracingIntegration } from "@sentry/solid/solidrouter";
import { config } from "~/data/config";

export const SENTRY_DSN =
  "https://b55cabac068029a3a974e675519226fc@o1172589.ingest.us.sentry.io/4507057400053760";

export const initSentry = () => {
  if (config.enableErrorLoggingToSentry) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: config.env,
      // integrations: [solidRouterBrowserTracingIntegration()],
      sendDefaultPii: true,
    });
  }
};

export const captureErrorInSentry = (err: Error) => {
  if (config.enableErrorLoggingToSentry) {
    Sentry.captureException(err);
  }
};

export const attachUserIdToSentry = (userId: string) => {
  if (config.enableErrorLoggingToSentry) {
    Sentry.setUser({ id: userId });
  }
};

export const clearUserFromSentry = () => {
  if (config.enableErrorLoggingToSentry) {
    Sentry.setUser(null);
  }
};

export const setClientIdTagInSentry = (clientId: string) => {
  // @ts-expect-error - window.Sentry is a valid property
  if (window.Sentry) {
    // @ts-expect-error - Sentry is a valid property
    window.Sentry.setTag("client_id", clientId);
  }
};
